import _ from 'underscore';
import { BlobResponse, CreateBlobOptions } from '../types';

/**
 * Calls ODATA to get a new blob (SAS URL + blob name)
 *
 * @param {Object} param0 - options.
 * @returns {Object} blob - Contains properties BlobName and SasUrl.
 */
export function createBlobWithOData({
  fileExtension,
  bulkFileType,
  odata,
  ajaxOptions,
}: CreateBlobOptions): BlobResponse {
  const getSASBlobUrl = `/BulkUploadFiles/GetBlobUploadUrl(CustomerId=:customer_id,BulkFileType=${bulkFileType},FileExtension=${fileExtension})`;

  // NOTICE: added ajaxOptions
  const options = _.defaults(
    {
      url: getSASBlobUrl,
    },
    ajaxOptions,
  );

  return odata.get(options);
}

/**
 * Calls ODATA to get a new blob using account id(SAS URL + blob name)
 *
 * @param {Object} param0 - options.
 * @returns {Object} blob - Contains properties BlobName and SasUrl.
 */
export function createBlobWithODataUsingAccountId({
  fileExtension,
  bulkFileType,
  odata,
  ajaxOptions,
}: CreateBlobOptions): BlobResponse {
  const getSASBlobUrl = `/BulkUploadFiles/GetBlobUploadUrl(AccountId=:account_id,BulkFileType=${bulkFileType},FileExtension=${fileExtension})`;

  // NOTICE: added ajaxOptions
  const options = _.defaults(
    {
      url: getSASBlobUrl,
    },
    ajaxOptions,
  );

  return odata.get(options);
}
